import { useEffect, useState } from "react";
import Header from "../components/Header/Header";

import Search from "../components/Search/Search";
import { Container, Row, Col } from "react-bootstrap";
import SidebarRight from "../components/SidebarRight/SidebarRight";

import { ReactSortable } from "react-sortablejs";
import ActivitiesCard from "../components/ActivitiesCard/ActivitiesCard";
import { getVideos } from "../services/videoService";
import { useParams } from "react-router";
import { getPrograms } from "../services/programService";

function randomIntFromInterval(min, max) {
  // min and max included
  return Math.floor(Math.random() * (max - min + 1) + min);
}

let lastKey = 1000;

const Build = () => {
  const [exercises, setExercises] = useState([]);
  const [editProgram, setEditProgram] = useState(null);
  let params =  useParams();
  let { id } = useParams();

  useEffect(() => {
    getVideos().then((videos) => {
      let formattedVideos = videos.map((v) => {
        v.elId = v.id;
        return v;
      });
      setExercises(formattedVideos);
    })
    if (id) {
      getPrograms(id).then(res => {
        setEditProgram(res[0]);
      })
    }
  }, []);

  return (
    <Container>
      <Row>
        <Col md={9} className="order-sm-0 order-1">
          <Header title="Build Program" />
          <Search />
          <ReactSortable
            list={exercises}
            setList={setExercises}
            className="row"
            group={{
              name: "shared",
              pull: "clone",
              put: false, // Do not allow items to be put into this list
            }}
            clone={(x) => {
              x.id = ++lastKey + "buildKey";
              return x;
            }}
            sort={false}
            chosenClass="chosen"
          >
            {exercises.map((item) => (
              <ActivitiesCard
                key={`${item.id}`}
                title={item.name}
                description={item.description}
                img={item.thumbnail}
                elId={item.elId}
                id={item.id}
              />
            ))}
          </ReactSortable>
          {/* TODO Crear un componente con esta parte */}
        </Col>
        <Col md={3} className="g-0 order-sm-1 order-0">
          <SidebarRight program={editProgram}/>
        </Col>
        {/* TODO Cambiar a  ProgramExcersisesList*/}
      </Row>
    </Container>
  );
};

export default Build;
